import type { UnapprovedInstructor } from '@features/instructors/api/get-instructors-unapproved/getInstructorsUnapproved.types';
import type { Instructor } from '@features/instructors/api/types/instructor.types';
import type { InstructorSection } from '@features/instructors/contexts/manage-instructors-selection/ManageInstructorsSelectionContext.types';

interface SectionConfig {
  key: InstructorSection;
  title: string;
  dataTestId: string;
}

const SECTION_CONFIGS: SectionConfig[] = [
  {
    key: 'groundSchool',
    title: 'Ground School',
    dataTestId: 'ground-school-section',
  },
  {
    key: 'simulator',
    title: 'Simulator Training',
    dataTestId: 'sim-training-section',
  },
  { key: 'simCheck', title: 'Checking', dataTestId: 'checking-section' },
];

function mapUnapprovedToInstructor(
  unapproved: UnapprovedInstructor
): Instructor {
  return {
    ...unapproved,
    // approvalId is not relevant in the context of the Manage Instructors Panel and is only used for rendering the InstructorsTile, so we can set it to an empty string to satisfy the Instructor type
    approvalId: '',
    programs: unapproved.programs.map(p => ({ id: p.id, disciplines: [] })),
  };
}

export { mapUnapprovedToInstructor, SECTION_CONFIGS };
export type { SectionConfig };
